import introJs from 'intro.js';
import './intro.css';
import './custom.less';

let introData = {}; // introduction实例集合
const introTooltipClass = 'platform-intro-tooltip';
window.onDesignerIntroClick = (tag, type) => { // 自定义区域事件
    // console.log('onDesignerIntroClick', tag, type);
    const currentIntro = introData[tag];
    if (type === 'close') {
        currentIntro.exit();
    }
};

/*
    @params Object
    type: tour/hint
    selector: without selector, start introduction for whole page, else start introduction for element id=selector
    tag: 特殊的introduction属性标识，依据该属性获取steps
    config: 配置项数组[{ title, desc, thumb, key }]
    events: 事件 { onbeforechange, onafterchange }
*/
const start = ({ isInsideTab, type = 'tour', selector = '', tag = 'intro-tour', config = null, events = null, json } = {}) => {
    if (!introData[tag]) {
        introData[tag] = selector ? introJs(selector) : introJs();
    }
    const introRes = introData[tag];
    introRes.setOptions(getOptions(type, tag, config, json));
    const startActionMap = {
        tour: 'start',
        hint: 'showHints',
    };
    const resEvents = {
        ...events,
        onbeforechange: (step, targetElement) => {
            // let overlayDom = document.getElementsByClassName('introjs-overlay')[0]
            // if (overlayDom && isInsideTab === 'true') {
            //     overlayDom?.classList?.add('resetoverlay')
            // }
            const skipLable = ` ${json['0006']} (${step}/${introRes._introItems.length})`;//跳过指引
            const lastSkipClass = 'skip-last-step';
            introRes.setOption('skipLabel', skipLable);
            let skipButton, buttonContainer;
            const tooltipContainer = document.querySelector(`.${introTooltipClass}.${tag}`);
            if (tooltipContainer) {
                buttonContainer = tooltipContainer.querySelector('.introjs-tooltipbuttons');
                if (buttonContainer) {
                    skipButton = buttonContainer.querySelector(`.${lastSkipClass}`);
                }
            }
            if (step === introRes._introItems.length) { // 最后一步加跳过指引
                if (skipButton) { return; }
                let skipHandle = () => {
                    skipButton.onclick = null;
                    skipButton.remove();
                    skipHandle = null;
                    introRes.exit();
                };
                skipButton = document.createElement('a');
                skipButton.className = `${introRes._options.buttonClass} introjs-skipbutton ${lastSkipClass}`;
                skipButton.text = skipLable;
                skipButton.onclick = skipHandle;
                buttonContainer.appendChild(skipButton);
            } else {
                skipButton && skipButton.remove();
            }
            events && events.onbeforechange && events.onbeforechange(step, targetElement);
        },
        onafterchange: (step, targetElement) => {
            let targetInfor = targetElement?.getBoundingClientRect();
            let scrollTop = document.documentElement.scrollTop;
            const viewHeight = window.innerHeight || document.documentElement.clientHeight;
            const viewWidth = window.innerWidth || document.documentElement.clientWidth;
            let tooltipReferenceLayer = document.getElementsByClassName('introjs-tooltipReferenceLayer')[0];
            let tooltipInfor = tooltipReferenceLayer?.getBoundingClientRect();
            console.log(targetInfor.width, viewWidth);
            if(targetInfor.top + scrollTop > viewHeight){
                targetElement.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
               
                // document.getElementsByClassName('desinger-intro-highlight')[0].style.setProperty('bottom', '-5px');
                // document.getElementsByClassName('desinger-intro-highlight')[0].style.setProperty('top', '');
                if(step === 1){
                    document.getElementsByClassName('desinger-intro-highlight')[0].style.setProperty('left', (targetInfor.left - 5) + 'px');
                }
                // tooltipReferenceLayer.style.setProperty('bottom', '0px');
                // tooltipReferenceLayer.style.setProperty('top', '');
            }
            //   console.log(arrowDom.style.display)
            // console.log(document.getElementsByClassName('introjs-disableInteraction')[0]?.getBoundingClientRect()) 
            setTimeout(() => {
                let tooltipDom = document.getElementsByClassName('introjs-tooltip')[0];
                let toolInfo = tooltipDom?.getBoundingClientRect();
                let helperDom = document.getElementsByClassName('introjs-helperLayer')[0];
                let helperInfo = helperDom?.getBoundingClientRect();
                // console.log('helperInfo',helperInfo)
                // console.log(toolInfo)
                let toolTop = toolInfo.top;
                let arrowDom = document.getElementsByClassName('introjs-arrow')[0];
                if (toolTop <= 0) {
                    // tip定位值=-按钮top
                    // arrow定位位置= tip高-按钮top-按钮高/2
                    // tooltipDom.style.setProperty('top', -targetInfor.top + targetInfor.height / 2 + 'px');
                    // arrowDom.style.setProperty('bottom', toolInfo.height - targetInfor.top - targetInfor.height / 2 + 'px');
                    if (Math.abs(targetInfor.width - viewWidth) < 350) {
                        if (helperInfo.bottom > viewHeight / 2 || viewHeight - helperInfo.height < 370) {
                            tooltipDom.style.setProperty('transform', '');
                            tooltipDom.style.setProperty('top', '');
                            tooltipDom.style.setProperty('bottom', '');
                            tooltipDom.style.setProperty('left', '50%');
  
                            arrowDom.classList.add('left');
                            arrowDom.classList.remove('bottom');
                            arrowDom.style.setProperty('bottom', '');
                        } 
                    } else { 
                        tooltipDom.style.setProperty('top', '-10px');
                        arrowDom.classList.add('left');
                        arrowDom.classList.remove('left-bottom');
                        arrowDom.style.setProperty('bottom', '');
                    }
                }
                // console.log(document.getElementsByClassName('introjs-arrow')[0].style.display)
                if (Math.abs(targetInfor.width - viewWidth) < 350 && arrowDom.style.display === 'none') { 
                    tooltipDom.style.setProperty('top', document.getElementsByClassName('introjs-disableInteraction')[0]?.getBoundingClientRect().height + 20 + 'px');
                    tooltipDom.style.setProperty('margin-top', '');
                    arrowDom.style.setProperty('display', 'block');
                    arrowDom.style.setProperty('bottom', '');
                    arrowDom.classList.add('top');
                    arrowDom.classList.remove('bottom');
                    arrowDom.classList.remove('left-bottom');
                    arrowDom.classList.remove('left');
                    arrowDom.classList.remove('right-bottom');
                    tooltipDom.style.setProperty('transform', 'translate(6px, -10px)');
                }
                if (Math.abs(targetInfor.width - viewWidth) < 350 && viewHeight - toolInfo.bottom < 370) {
                    if (helperInfo.bottom > viewHeight / 2 || viewHeight - helperInfo.height < 370) {
                        tooltipDom.style.setProperty('transform', 'translate(300px, -180px)');
                        arrowDom.classList.add('left');
                        arrowDom.classList.remove('top');
                    } 
                } 
                if (arrowDom.classList.contains('right-bottom') || arrowDom.classList.contains('right')) { 
                    tooltipDom.style.setProperty('transform', 'translate(-10px,-10px)');
                }
                if (viewHeight - helperInfo.bottom < 12) { 
                    helperDom.style.setProperty('width', (helperInfo.width - 5) + 'px');
                    helperDom.style.setProperty('height', (helperInfo.height - 5) + 'px');
                    // tooltipReferenceLayer.style.setProperty('width', (helperInfo.width - 10) + 'px');
                    // tooltipReferenceLayer.style.setProperty('height', (helperInfo.height - 5) + 'px');
                    document.getElementsByClassName('introjs-disableInteraction')[0].style.setProperty('height', '');
                    if (arrowDom.classList.contains('right') || arrowDom.classList.contains('left')) {
                        tooltipDom.style.setProperty('transform', 'translate(0px, 0px)');
                  
                    } else if (arrowDom.classList.contains('right-bottom')) {
                        helperDom.style.setProperty('width', '');
                        helperDom.style.setProperty('height', '');
                        tooltipDom.style.setProperty('transform', 'translate(6px, -20px)');
                    } else if (arrowDom.classList.contains('left-bottom')) { 
                        tooltipDom.style.setProperty('transform', 'translate(0px, -20px)');
                        arrowDom.style.setProperty('bottom', '');
                    }else {
                        tooltipDom.style.setProperty('transform', 'translate(6px, 0px)');
                    }
                }
                if (helperInfo.width > viewWidth) { 
                    if (arrowDom.classList.contains('top')) { 
                        tooltipDom.style.setProperty('left', '50%');
                    }
                    helperDom.style.setProperty('width', 'auto');
                    document.getElementsByClassName('introjs-disableInteraction')[0].style.setProperty('width', 'auto');
                    // tooltipReferenceLayer.style.setProperty('width', viewWidth + 'px');
                }
            }, 400);
        },
        onchange: (step, targetElement) => {
            // console.log('onchange', step, targetElement)
        },
    };
    if (resEvents) {
        for (let k in resEvents) {
            introRes[k](targetElement => {
                resEvents[k](introRes._currentStep + 1, targetElement);
            });
        }
    }
    introRes[startActionMap[type]]();
    return introRes;
};

const getOptions = (type, tag, config, json) => {
    let introArr = [];
    const introNodes = document.querySelectorAll(`[${tag}]`);
    if (config) {
        config.forEach(conf => {
            // let desc = getMsg(conf.desc)
            // console.log(typeof desc)
            const introNode = conf.element || Array.from(introNodes).find(item => item.getAttribute(tag) === conf.key);
            let introContent = `<div class="tourist-content">
                ${conf.thumb ? `<img class='tourist-img' src=${conf.thumb}></img>` : ''}
                ${type === 'tour' ? `<div class="bullets-placeholder"></div><i class="iconfont icon-guanbi intro-close" onclick="onDesignerIntroClick('${tag}', 'close')"></i>` : ''}
                <span class='tourist-title'>${conf.title}</span>
                <p class='tourist-desc'>${conf.desc || conf.html}</p>
            </div>`;
            const commonStep = { element: introNode, position: conf.position };
            if (type === 'tour') {
                introArr.push({
                    ...commonStep,
                    intro: introContent,
                });
            } else if (type === 'hint') {
                introArr.push({
                    ...commonStep,
                    hint: introContent,
                });
            }
        });
    }
    const typeMap = {
        tour: {
            tooltipClass: `${introTooltipClass} ${tag}`,
            buttonClass: 'desinger-intro-button',
            steps: introArr,
            showStepNumbers: false, // Show steps number in the red circle or not, true or false
            nextLabel: json['0007'], //'下一步',
            prevLabel: json['0008'], //'上一步',
            skipLabel: json['0006'], // '跳过指引',
            doneLabel: json['0009'], //'完成',
            hidePrev: true, // Hide the previous button in the first step
            hideNext: true, // Hide the next button in the last step
            highlightClass: 'desinger-intro-highlight',
            overlayOpacity: 0.5,
            disableInteraction: true,
            // 设置背景不关闭步骤
            exitOnOverlayClick: false,
            positionPrecedence: ['right', 'left', 'bottom', 'top'],
            scrollToElement: true,
        },
        hint: {
            tooltipClass: 'desinger-hint-tootip',
            buttonClass: 'desinger-hint-button',
            hints: introArr,
            hintButtonLabel: json['0001'], //'我知道了'
        },
    };
    return { ...typeMap[type] };
};

/*
    @params Object
    tag: 特殊的introduction属性标识，依据该属性获取steps
    config: 配置项{ title, desc, thumb }
*/
const startHintDialog = (params = {}) => {
    const targetEle = event.target;
    const introRes = start({ ...params, type: 'hint', config: [{ ...params.config, element: targetEle }] });
    let hintsContainer;
    introRes._introItems.forEach(hintDot => {
        hintDot.element.style.visibility = 'hidden'; // 隐藏hint圆点
        !hintsContainer && (hintsContainer = hintDot.element.parentElement);
    });
    let removeHint = () => {
        hintMask.onclick = null;
        hintMask.remove();
        hintsContainer && hintsContainer.remove();
        hintsContainer = null;
        removeHint = null;
    };
    const hintMask = document.createElement('div');
    hintMask.className = 'introjs-overlay intro-hint-mask';
    hintMask.onclick = removeHint;
    introRes._targetElement.appendChild(hintMask);
    setTimeout(() => {
        introRes.showHintDialog(0).onhintclose(removeHint);
    });
};

const intro = {
    start,
    startHintDialog,
};

export default intro;
